import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { NavigationState, NavigationItem, NavigationFooterItem } from '../../types/AllyNavigationTypes';
import { fetchNavigationItems } from '../../services/navigation/AllyNavigationService';

const initialState: NavigationState = {
  items: [],
  footer: [],
  loading: false,
  error: null,
  navMenuTap: false,
};

// Async thunk for fetching navigation data
export const fetchNavigationData = createAsyncThunk('navigation/fetchNavigationData', async () => {
  const response = await fetchNavigationItems();
  return response;
});

const AllyNavigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setNavigationItems: (state, action: PayloadAction<NavigationItem[]>) => {
      state.items = action.payload;
    },
    setNavigationFooter: (state, action: PayloadAction<NavigationFooterItem[]>) => {
      state.footer = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    setNavMenuTap: (state, action: PayloadAction<boolean>) => {
      state.navMenuTap = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNavigationData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNavigationData.fulfilled, (state, action) => {
        state.loading = false;
        // Extract mainSidebar data from the new response structure
        const mainSidebar = action.payload.menu?.find((menu) => menu.name === 'mainSidebar');
        if (mainSidebar) {
          state.items = mainSidebar.items;
          state.footer = mainSidebar.footers;
        } else {
          console.warn('mainSidebar not found in navigation response');
          state.items = [];
          state.footer = [];
        }
      })
      .addCase(fetchNavigationData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch navigation data';
      });
  },
});

export const { setNavigationItems, setNavigationFooter, clearError, setNavMenuTap } = AllyNavigationSlice.actions;
export default AllyNavigationSlice.reducer;
